/* eslint-disable @next/next/no-html-link-for-pages */
import { useTranslation } from 'next-i18next';

import { Button } from '@chakra-ui/react';

import { Error } from '@app/components/organisms/error';
import { environment } from '@app/environments/environment';

export const NotFound = () => {
    //TODO we should move it to ceph
    const imgSrc = `${
        environment.NOCIMG_URL || 'https://d.nocimg.pl/'
    }gfx/nocowanie_pl/mf/common/error/error.svg`;

    const { t } = useTranslation('common');

    return (
        <Error
            code={404}
            imgSrc={imgSrc}
            translationData={{
                reason: t('errorPage.notFoundReason'),
            }}
        >
            <Button asChild colorPalette="secondary">
                <a href="/">{t('errorPage.goBack')}</a>
            </Button>
        </Error>
    );
};
